import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: (
      typeof window !== 'undefined' && window.env
        ? `${window.env.api_base_url}/v1/`
        : (`${process.env.API_BASE_URL}/v1/` || 'http://localhost:3000/v1/')
    ),
    credentials: 'include',
    prepareHeaders(headers, { extra: cookies }) {
      if (cookies) {
        headers.set('Cookie', cookies);
      }

      return headers;
    }
  }),
  tagTypes: ['Notifications', 'User', 'Preload', 'Subscription'],
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      query: () => 'sessions',
      transformResponse(baseQueryReturnValue) {
        const { meta, data } = baseQueryReturnValue;

        if (data) {
          return {
            ...data[0],
            _meta: meta,
          }
        }

        return null;
      },
      providesTags: ['User']
    }),
    getNotifications: builder.query({
      query: () => 'notifications',
      transformResponse(baseQueryReturnValue) {
        return [
          // TODO: Remove this
          // { flag: 'SUBSCRIPTION', sub_flag: 'TRIAL_EXPIRED', read: false },
          ...baseQueryReturnValue.data
        ];
      },
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Notifications', id })), 'Notifications', 'User']
          : ['Notifications', 'User'],
    }),
    getStripeBillingPortal: builder.query({
      query: () => 'sessions/billing_link',
      transformResponse(baseQueryReturnValue) {
        return baseQueryReturnValue.data
      },
    }),
    getPreload: builder.query({
      query: () => 'ssr_preload',
      providesTags: ['Preload']
    }),
    createSubscription: builder.mutation({
      query: ({ subscriptionPlan, tag, quantity, couponCode, currency }) => ({
        url: 'subscriptions',
        method: 'POST',
        body: { subscriptionPlan, tag, quantity, couponCode, currency },
      }),
      transformResponse(baseQueryReturnValue) {
        const { meta, data } = baseQueryReturnValue;

        if (data) {
          return {
            ...data[0],
            _meta: meta,
          }
        }

        return null;
      },
      providesTags: ['Subscription'],
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCurrentUserQuery,
  useGetNotificationsQuery,
  useGetStripeBillingPortalQuery,
  useGetPreloadQuery,
  useCreateSubscriptionMutation,
} = api;
